import { useJsonToCsv } from "react-json-csv";

function useDownloadCsv(data, fields, filename) {
  const { saveAsCsv } = useJsonToCsv();

  return saveAsCsv({ data, fields, filename });
}
export default useDownloadCsv;
